export const FONT_STACK =
  '"Inter Variable", Inter, system-ui, -apple-system, "Segoe UI", Roboto, sans-serif';

// A deliberate subset of _tokens.scss: chart series, status backgrounds and
// surface-hover live in SCSS alone because AntD does not consume them.
// theme.constants.test.ts enforces the direction TOKENS ⊆ SCSS.
//
// Hand-copied from _tokens.scss, so the two files have to move together.
export const TOKENS = {
  brand: '#3d24db',
  brandStrong: '#2e1aae',
  brandDeep: '#1f0f72',
  brandSoft: '#edeafc',
  brandBorder: '#dcd6fa',
  ink: '#12131c',
  muted: '#6b7080',
  line: '#ecedf3',
  bg: '#f6f7fb',
  card: '#ffffff',
  success: '#178a50',
  successSoft: '#e5f5ec',
  warning: '#b4690e',
  info: '#1c6fb8',
  danger: '#c0392b',
  radiusControl: 12,
  radiusCard: 18,
} as const;
